import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'lk-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ArticleComponent implements OnInit {
  public article;

  constructor(private route: ActivatedRoute,
              private sanitized: DomSanitizer ) { }

  ngOnInit() {
    this.route
      .params
      .flatMap( param => {
        return this.route
          .parent
          .parent
          .data
          .map( data => {
            return data.data[ 1 ].find( e => { return e.id === +param.id; } );
          });
      })
      .subscribe(
        article => this.article = article
      );
  }

  getHtml(){
    return this.sanitized.bypassSecurityTrustHtml(this.article.html);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/article/article.component.ts